export default "__VITE_ASSET__BHlO3OlQ__"